// gimme: conversations-inbox-ui 06/09/2020 131cc2650403ed82bcd02adbe470fec8b864e1c9
import invariant from 'react-utils/invariant';
export const messageKeyInvariant = messageKey => invariant(typeof messageKey === 'string', 'Expected messageKey to be a `String` not a `%s`', typeof messageKey);